// CANONICAL COPY: installations\smart-td\content\claimBarsTable.js (ruling 321 slice 3c, task list section 737). src\data\claimBarsTable.js is its
// projection, written by scripts\sync-installation.js - EDIT THE CANONICAL. An edit made only to the projection is refused by the cycle.
// DATA ONLY (section 737): lifted verbatim out of src\data\claimBars.js, which keeps the code and re-exports every name here.
export const CLAIM_BARS = [
  {
    agreementKey: 'BN Yardmaster Agreement',
    agreementName: 'BN Yardmaster Schedule Agreement (1997)',
    categoryId: 'meal',
    rule: 'Rule 2(F)',
    quote: 'Any existing agreement provisions requiring that Yardmasters receive an uninterrupted meal period or specified time periods for a meal period are eliminated, and no Yardmaster may progress any claim or grievance on the basis of not receiving an uninterrupted meal period.',
    source: 'data/agreements/BN_YM_Schedule_1997-05-10.source.txt:238-241',
    alsoAt: {
      rule: 'BN 1994 Memorandum, Article VIII.A',
      quote: 'Any existing agreement provisions requiring that yardmasters receive an uninterrupted meal period or specified time periods for a meal period are eliminated, and no yardmaster may progress any claim or grievance on the basis of not receiving an uninterrupted meal period.',
      source: 'data/agreements/BN_YM_Memorandum_1994.ocr.txt:325-328',
      note: 'OCR text; not read against the page image.',
    },
    docRow: 'data/YCP_CARRIER_VIOLATION_CATEGORIES_2026-10-07.md:875,877',
  },
  {
    agreementKey: 'BN Yardmaster Agreement',
    agreementName: 'BN Yardmaster Schedule Agreement (1997)',
    categoryId: 'held_over',
    rule: 'Rule 2(G)',
    quote: 'Any existing agreement provisions or practices that result in additional compensation to yardmasters for turnover time are eliminated.',
    source: 'data/agreements/BN_YM_Schedule_1997-05-10.source.txt:248-249',
    note: 'Turnover time only.',
    docRow: 'data/YCP_CARRIER_VIOLATION_CATEGORIES_2026-10-07.md:876',
  },
  {
    agreementKey: 'BN Yardmaster Agreement',
    agreementName: 'BN Yardmaster Schedule Agreement (1997)',
    categoryId: 'seniority',
    rule: 'Rule 7(C)',
    quote: 'Once a Yardmaster, who has established seniority as such, has been assigned to an ROA position and has worked thereon for more than 60 full shifts, if s/he is subsequently removed from the ROA position and another employee is assigned to the ROA position, the employee who is removed may challenge his or her removal through the formal grievance procedure. To successfully challenge the removal from the ROA position, s/he must show that the Carrier\'s decision to remove him or her from the position was without just cause.',
    source: 'data/agreements/BN_YM_Schedule_1997-05-10.source.txt:502-507',
    note: 'Removal from a Right-of-Appointment (ROA) position: a condition on the claim, not a full bar.',
    docRow: 'data/YCP_CARRIER_VIOLATION_CATEGORIES_2026-10-07.md:878',
  },
  {
    agreementKey: 'D&H/CP Yardmaster Agreement (eff. April 15, 2007)',
    agreementName: 'D&H/CP Yardmaster Agreement (2007)',
    categoryId: 'displacement',
    rule: 'Appendix 8, Yardmasters Supplemental Displacement Agreement, item 6',
    quote: 'No part of this Agreement shall be used against the Carrier, in any manner whatsoever, either directly or indirectly, as a basis for a grievance or time claim by or on behalf of any employee.',
    source: 'data/agreements/dh-codified-2007.source.txt:3955-3957',
    note: '"this Agreement" is the Yardmasters Supplemental Displacement Agreement (line 3918), the once-a-year displacement letter.',
    docRow: 'data/YCP_CARRIER_VIOLATION_CATEGORIES_2026-10-07.md:879',
  },
  {
    agreementKey: 'D&H/CP Yardmaster Agreement (eff. April 15, 2007)',
    agreementName: 'D&H/CP Yardmaster Agreement (2007)',
    categoryId: 'scope',
    rule: 'Appendix 8, Letter No. 2 (July 12, 1990)',
    quote: 'It is understood that the Yardmaster\'s classification does not have work exclusivity to the aforementioned duties and the Carrier will not be required to establish a Yardmaster\'s position where the volume of work does not warrant it. The Carrier will not use the provisions of this letter of understanding to abolish a Yardmaster\'s position and establish a position doing essentially the same duties in another classification.',
    source: 'data/agreements/dh-codified-2007.source.txt:3894-3896',
    docRow: 'data/YCP_CARRIER_VIOLATION_CATEGORIES_2026-10-07.md:880',
  },
  {
    agreementKey: 'D&H/CP Yardmaster Agreement (eff. April 15, 2007)',
    agreementName: 'D&H/CP Yardmaster Agreement (2007)',
    categoryId: 'training',
    rule: 'Appendix 8, letter of October 10, 2006 (Binghamton TYC vacancies), item 2',
    quote: 'The decision on which Yardmasters are qualified to fill a TYC\'s vacancy, if any, rests solely with the Carrier, and not a topic for dispute or claim.',
    source: 'data/agreements/dh-codified-2007.source.txt:4099-4100',
    note: 'Filling Binghamton Train Yard Coordinator (TYC) short-term vacancies with Yardmasters (lines 4083-4084).',
    docRow: 'data/YCP_CARRIER_VIOLATION_CATEGORIES_2026-10-07.md:881',
  },
  {
    agreementKey: 'CSX Yardmaster System Agreement (eff. July 1, 2002)',
    agreementName: 'CSX Yardmaster System Agreement (2002)',
    categoryId: 'union',
    rule: 'Addendum A (Deduction Agreement), paragraph (9)',
    quote: 'No part of this Agreement shall be used in any manner whatsoever either directly or indirectly, as a basis for a grievance or time claim by or in behalf of any employee; likewise, no part of any other agreement between the Carrier and the Union shall be used as a basis for a grievance or time claim by or in behalf of any employee predicated upon compliance or failure to comply with the provisions of this Agreement.',
    source: 'data/agreements/csx-2002-system-agreement.source.txt:4152',
    note: 'Union dues deduction (Addendum A, line 4092-4094).',
    docRow: 'data/YCP_CARRIER_VIOLATION_CATEGORIES_2026-10-07.md:882',
  },
  {
    agreementKey: null,   // Metro-North is not an agreement on the platform (no AGREEMENT_LOOKUP entry) - shows to no one yet
    agreementName: 'Metro-North Yardmaster Agreement (ACRE/UTU)',
    categoryId: 'pay',
    rule: 'Letter of January 13, 2000 (Yardmaster Classifications)',
    quote: 'The parties have discussed the potential for additional delegation of duties and responsibilities to the Yardmasters and agree that these ... duties will be accepted without objection by the UTU-YM and without any claims for additional compensation.',
    source: 'data/agreements/incoming/mnr_acre_yardmaster_1995-1998.txt:2406-2419',
    note: 'Newly delegated duties. " ... " marks the page footer and the next page\'s heading (lines 2409-2417), omitted.',
    docRow: 'data/YCP_CARRIER_VIOLATION_CATEGORIES_2026-10-07.md:883',
  },
  {
    agreementKey: null,   // Tacoma Rail is not an agreement on the platform (no AGREEMENT_LOOKUP entry) - shows to no one yet
    agreementName: 'Tacoma Rail Yardmaster Agreement (2025-2028)',
    categoryId: 'extra_board',
    rule: 'Section 2.7.3',
    quote: 'Extra list Yardmasters may be held from service in other craft to protect a known vacancy, within the 24-hour work day. No claim will be valid as a result of being withheld.',
    source: 'data/agreements/incoming/tacoma_smart-td_yardmaster_cba_2025-2028.txt:345-347',
    docRow: 'data/YCP_CARRIER_VIOLATION_CATEGORIES_2026-10-07.md:884',
  },
];
